<div class="mt-8 mb-4">

    @let roles = myRoles$ | async;

    <div class="flex justify-between items-center w-full mb-4">

        <div class="flex flex-row justify-between items-center w-full">
            <app-btn-back [routeTo]="'/school/' + groupId + '/quizzes'" [replaceUrl]="true"></app-btn-back>
            @if (quiz?.quizStatus === quizStatus.draft && ((roles.faculty && quiz?.createdById === user?.uid) ||
            roles.management)) {
            <app-btn-route btnText="Edit Quiz" icon="fa fa-edit"
                colors="bg-primary-500 hover:bg-primary-700 active:bg-primary-500" routeTo="edit"></app-btn-route>
            }
            @if (quiz?.quizStatus === quizStatus.completed || isQuizExpired()) {
            <div
                class="bg-slate-50 text-slate-600 px-4 py-2 rounded-md border border-slate-200 text-sm font-medium flex items-center gap-2">
                <i class="fa fa-clock"></i>
                <span>This quiz has ended and is no longer accepting attempts.</span>
            </div>
            } @else if (quiz?.quizStatus === quizStatus.scheduled || (quiz?.isLive && (quiz?.quizStatus === quizStatus.waiting
            || quiz?.quizStatus === quizStatus.inProgress))) {
            @if (quiz?.isLive) {
            @if (roles?.management || roles?.faculty) {
            <!-- Host Split Button for Live Quiz -->
            <div class="relative inline-flex rounded-lg shadow-sm bg-primary-500">
                <!-- Main Button: default hosts the quiz -->
                <button type="button" (click)="hostLiveQuiz()"
                    class="relative inline-flex items-center rounded-l-lg bg-primary-500 hover:bg-primary-700 active:bg-primary-500 hover:shadow-lg px-4 py-2 text-sm font-semibold text-white focus:outline-none transition-all duration-150 min-h-[40px]">
                    <i class="fa fa-play mr-2"></i>
                    <span>Host Quiz</span>
                </button>
                <div class="min-w-0.5 min-h-8 max-h-8 bg-white my-auto rounded-full"></div>
                <!-- Dropdown Trigger Button -->
                <button type="button" (click)="toggleDropdown($event)"
                    class="relative -ml-px inline-flex items-center rounded-r-lg bg-primary-500 hover:bg-primary-700 active:bg-primary-500 hover:shadow-lg px-3 py-2 text-sm font-semibold text-white focus:outline-none transition-all duration-150 border-l border-primary-600 min-h-[40px]">
                    <i class="fa fa-chevron-down text-xs"></i>
                </button>

                <!-- Dropdown Panel -->
                @if (showDropdown()) {
                <div
                    class="absolute right-0 z-50 mt-11 w-56 origin-top-right rounded-lg bg-white border border-slate-200 shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none py-1">
                    <button type="button" (click)="hostLiveQuiz()"
                        class="w-full text-left px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 active:bg-slate-100 flex items-center gap-2">
                        <i class="fa fa-tv text-slate-400 w-4"></i>
                        <span>Host Quiz Room</span>
                    </button>
                    <button type="button" (click)="attemptOrJoinQuiz()"
                        class="w-full text-left px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 active:bg-slate-100 flex items-center gap-2">
                        <i class="fa fa-user-edit text-slate-400 w-4"></i>
                        <span>Attempt Quiz</span>
                    </button>
                </div>
                }
            </div>
            } @else {
            @if (quiz?.allowMultipleAttempts === false && hasExistingAttempt()) {
            <div
                class="bg-red-50 text-red-700 px-4 py-2 rounded-md border border-red-200 text-sm font-medium flex items-center gap-2">
                <i class="fa fa-exclamation-triangle"></i>
                <span>Multiple attempts are not allowed for this quiz.</span>
            </div>
            } @else {
            <app-btn-action label="Join Live Quiz" icon="fa fa-right-to-bracket"
                [inProgress]="(isWorking$ | async) ?? false"
                bgColor="bg-primary-500 hover:bg-primary-700 active:bg-primary-500"
                (click)="attemptOrJoinQuiz()"></app-btn-action>
            }
            }
            } @else {
            <!-- Non-live (Scheduled) Quiz -->
            @if (quiz?.allowMultipleAttempts === false && hasExistingAttempt() && !(roles?.management ||
            roles?.faculty)) {
            <div
                class="bg-red-50 text-red-700 px-4 py-2 rounded-md border border-red-200 text-sm font-medium flex items-center gap-2">
                <i class="fa fa-exclamation-triangle"></i>
                <span>Multiple attempts are not allowed for this quiz.</span>
            </div>
            } @else {
            <app-btn-action label="Attempt Quiz" icon="fa fa-play" [inProgress]="(isWorking$ | async) ?? false"
                bgColor="bg-primary-500 hover:bg-primary-700 active:bg-primary-500"
                (click)="startQuiz()"></app-btn-action>
            }
            }
            }
            @if (quiz?.quizStatus === quizStatus.cancelled) {
            <div
                class="bg-red-50 text-red-700 px-4 py-2 rounded-md border border-red-200 text-sm font-medium flex items-center gap-2">
                <i class="fa fa-ban"></i>
                <span>This quiz has been cancelled.</span>
            </div>
            }
        </div>

    </div>

    <div class="flex flex-col mb-4 border-0 w-full">
        <div class="flex flex-row justify-between flex-wrap">
            <h1 class="font-semibold text-2xl text-primary-500">
                Quiz Details - {{ quiz?.title }}
            </h1>
            @if (quiz?.quizStatus == quizStatus.scheduled && quiz?.byInvite && quiz?.inviteCode && (roles.management ||
            (roles.faculty &&
            quiz?.createdById === user?.uid))) {
            <div class="flex flex-1 justify-end">
                <div class="flex flex-col justify-start sm:justify-end items-start sm:items-end">
                    <span class="text-primary-300 text-right w-full">Room Code</span>
                    <div class="flex flex-row gap-2 items-center justify-end">
                        <span class="text-primary-500 font-bold text-2xl">{{ quiz?.inviteCode }}</span>
                        <app-btn-fab icon="fa fa-copy" bgColor="bg-transparent hover:bg-white active:bg-gray-300"
                            (click)="copyInviteCode()"></app-btn-fab>
                    </div>
                </div>
            </div>
            }
        </div>

    </div>

    <div class="w-full mt-6">
        <!-- Tabs Navigation -->
        <div class="border-b border-gray-200 mb-6">
            <nav class="flex space-x-4">
                <app-btn-tab tabName="details" routerLink="details" queryParamsHandling="merge"
                    [isActive]="activeTab === 'details'">
                </app-btn-tab>
                @if (roles?.management || (roles?.faculty && quiz?.createdById === user?.uid)) {
                <app-btn-tab tabName="analytics" routerLink="analytics" queryParamsHandling="merge"
                    [isActive]="activeTab === 'analytics'">
                </app-btn-tab>
                }
            </nav>
        </div>

        <!-- Tab Content -->
        <router-outlet></router-outlet>
    </div>

</div>